<template>
  <Teleport to="body" defer>
    <Transition name="fade-down">
      <div v-if="toasts.length" class="ui-toasts">
        <TransitionGroup name="fade-down">
          <UiToast
            v-for="toast in toasts"
            :key="toast.id"
            :type="toast.type"
            :message="toast.message"
            :closable="toast.closable"
            :duration="toast.duration"
            @close="remove(toast.id)"
          />
        </TransitionGroup>
      </div>
    </Transition>
  </Teleport>
</template>
<script setup lang="ts">
import { useToast } from '@/composables/toast'
const { toasts, remove } = useToast()
</script>

<style lang="sass" scoped>
@use '@/styles/variables'

.ui-toasts
  position: absolute
  inset: variables.$spacer * 2 variables.$spacer auto variables.$spacer
  z-index: 10000
  display: flex
  flex-direction: column
  align-items: center
  gap: variables.$spacer
  pointer-events: none

  :deep(.ui-toast)
    pointer-events: auto
</style>
